// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1cf19c73","498":"221eedf8","703":"1dec9956","787":"61d16836"}[chunkId] + ".chunk.js";
};